import dayjs from "dayjs"
import {
  getGraphQlUri,
  isSuperAdminUser,
  CLASSROOM_DE_COURSE_TYPE_ID,
  DEFAULT_STUDENT_SITE_POLL_INTERVAL_MS,
} from "@coast/utils"

export { CLASSROOM_DE_COURSE_TYPE_ID, DEFAULT_STUDENT_SITE_POLL_INTERVAL_MS }
import { GQLInitiatedBy } from "./graphqlTypes"

/* eslint-disable no-console */
const graphqlNextUrlProd = "https://coastlineacademy.com/api/graphql"
const graphqlNextUrlDev = "https://nextdev.coastlineacademy.com/api/graphql"
const graphqlNextUrlTest =
  process.env.REACT_APP_GRAPHQL_NEXT_URL ?? "http://127.0.0.1:8000/api/graphql"
const nextApiUrlProd = "https://coastlineacademy.com/api"
const nextApiUrlDev = "https://nextdev.coastlineacademy.com/api"
const nextApiUrlTest =
  process.env.REACT_APP_NEXT_API_URL ?? "http://127.0.0.1:8000/api"

const serverUrlProd =
  "https://us-central1-coastline-new-driver.cloudfunctions.net/api"
const serverUrlDev =
  "https://us-central1-coastline-new-driver-dev.cloudfunctions.net/api"
const serverUrlTest =
  "https://us-central1-coastline-new-driver-test.cloudfunctions.net/api"
const localUrlTest =
  process.env.REACT_APP_FUNCTIONS_URL ??
  "http://127.0.0.1:5001/coastline-new-driver-test/us-central1/api"

const ENV = process.env.REACT_APP_ENV

export const COASTLINE_SERVICE_URL =
  "https://coastlineservice-mqq275yvla-wl.a.run.app"
export const COASTLINE_GATEWAY_URL =
  "https://coastline-complete-gateway-4vq3k8kn.uc.gateway.dev"

let projectUrl
let localSchedulingApiKey = "coastline-dev-key"
let localGraphqlNextUrl
let localNextApiUrl
let localRefundAmountSuggestionEnabled = true
let localSchedulingApiUrl =
  "https://scheduleoptimizerservice-mqq275yvla-wl.a.run.app"

if (ENV === "production") {
  projectUrl = serverUrlProd
  localSchedulingApiKey = "coastline-api-key-123"
  localGraphqlNextUrl = graphqlNextUrlProd
  localNextApiUrl = nextApiUrlProd
  localRefundAmountSuggestionEnabled = false
} else if (ENV === "test") {
  // eslint-disable-next-line no-restricted-globals
  if (process.env.REACT_APP_FUNCTIONS_URL) {
    console.log("Using configured local server")
    projectUrl = localUrlTest
    localGraphqlNextUrl = graphqlNextUrlTest
    localNextApiUrl = nextApiUrlTest
  } else if (location.hostname === "127.0.0.1") {
    console.log("Using LOCAL server")
    projectUrl = localUrlTest
    localGraphqlNextUrl = graphqlNextUrlTest
    localNextApiUrl = nextApiUrlTest
    // eslint-disable-next-line no-restricted-globals
  } else if (location.hostname === "localhost") {
    throw new Error("using wrong hostname: localhost")
  } else {
    console.log("Using test server")
    projectUrl = serverUrlTest
    localGraphqlNextUrl = getGraphQlUri()
    localNextApiUrl = process.env.REACT_APP_NEXT_API_URL ?? "/api"
  }
  localSchedulingApiKey = "coastline-test-key"
  localSchedulingApiUrl = process.env.REACT_APP_SCHEDULING_MATRIX_URL || ""
} else if (ENV === "development") {
  console.log("Using dev server")
  localSchedulingApiKey = "coastline-dev-key"
  projectUrl = serverUrlDev
  localGraphqlNextUrl = graphqlNextUrlDev
  localNextApiUrl = nextApiUrlDev
} else {
  console.error("Unknown environment")
  projectUrl = serverUrlDev
  localGraphqlNextUrl = graphqlNextUrlDev
  localNextApiUrl = nextApiUrlDev
}
export const serverUrl = projectUrl
export const schedulingApiKey = localSchedulingApiKey
export const graphqlNextUrl = localGraphqlNextUrl
export const nextApiUrl = localNextApiUrl
export const gatewayPublicApiKey = "AIzaSyAZCMFHpSKTLytYE1ndFEwyxN6AdqsqfUE"
export const schedulingApiUrl = localSchedulingApiUrl

export const phoneNumber = "(800) 489-1896"
export const officeHours = "from 7am to 8pm Pacific Time, 7 days a week"
export const DEFAULT_TIMEZONE = "America/Los_Angeles"

export const genericUserErrorMessage = `An error has occurred on our end, please contact support at: ${phoneNumber}.`

export const googleMerchantId = "128024605"

export const cloudinaryKey = "723563355487971"
export const cloudinaryUrl =
  "https://api.cloudinary.com/v1_1/coastline-academy/image/upload"
export const cloudinaryUploadPreset = "pkiglwvt"

// Don't let someone book a 9am lesson until the afternoon lesson is booked
// Only applied September through April.
export const preferAfternoons = (() => {
  const now = dayjs()
  const month = now.month() // 0-11
  return month >= 8 || month <= 3 // Sept (8) through April (3)
})()

export const refundAmountSuggestionEnabled = localRefundAmountSuggestionEnabled

export const PRISMIC_URL = "https://driversed.cdn.prismic.io/api/v2"
// for content editing.
export const DATO_URL =
  "https://coastline-courses.admin.datocms.com/editor/item_types/1620977/items/"
export const PRISMUC_BASE_URL =
  "https://driversed.prismic.io/documents~c=published&l=en-us/"

export const PURCHASE_LOG_CATEGORIES = [
  {
    id: "stripe",
    label: "Stripe",
  },
  {
    id: "paypal",
    label: "Paypal",
  },
  {
    id: "voucher",
    label: "Voucher",
  },
  {
    id: "charter",
    label: "Charter School",
  },
  {
    id: "corporate",
    label: "Organization",
  },
  {
    id: "cashCheck",
    label: "Cash or Check",
  },
  {
    id: "cash",
    label: "Cash",
  },
  {
    id: "check",
    label: "Check",
  },
  {
    id: "comp",
    label: "Complimentary",
  },
  {
    id: "complimentary",
    label: "Complimentary",
  },
  {
    id: "transfer",
    label: "Transfer",
  },
  {
    id: "acquisition",
    label: "Acquisition Prepaid",
  },
  {
    id: "notApplicable",
    label: "Not Applicable",
  },
  {
    id: "na",
    label: "Not Applicable",
  },
]

export const PURCHASE_LOG_CATEGORIES_FOR_FORMS = PURCHASE_LOG_CATEGORIES.filter(
  ({ id }) =>
    // Only list GQL-specific values here, and exclude the old cashCheck category
    id !== "na" && id !== "comp" && id !== "cashCheck",
)

export const DAYS_AT_A_TIME = 4

// This is actually number of 5-star reviews
export const NUM_REVIEWS = "100,000"
export const NUM_STUDENTS = "250,000"

export const CONTACT_MODAL_OPENED_VALUE = 10

export const SUPPORT_EMAIL = "hello@coastlineacademy.com"

export const SAMSARA_BASE_URL = "https://cloud.samsara.com/o/47792/devices"

export const DRIVERS_ED_COURSE_TYPE_ID = "90756890"

export const DEFAULT_MIN_LEAD_HOURS = 3

export const DEFAULT_MAX_DURATION_MINUTES = 3 * 120

export const DATE_SAFEGUARD_YEARS = 5

export const INITIATED_BYS = [
  "Student",
  "Instructor",
  "Coastline",
  "Immediate Reschedule",
]

export const toGQLInitiatedBy: Record<string, GQLInitiatedBy> = {
  Student: GQLInitiatedBy.Student,
  Instructor: GQLInitiatedBy.Instructor,
  Coastline: GQLInitiatedBy.Coastline,
  "Immediate Reschedule": GQLInitiatedBy.Immediate_Reschedule,
}

export const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoiaGFydml0cm9uaXgiLCJhIjoiY2phd3cwZDM5MG9iZzJxczdrN25ld3c2NCJ9.-Na1Ha6J3xz-v5nWadaiiQ"

export const DEFAULT_TX_BRANCH_ID = "C3371"

export const CANNOT_MANAGE_AVAILS_MSG =
  "Your availability is managed by your manager. Please reach out to make changes to your schedule."

const allowLessonNotificationsUsers = new Set([
  "UmwZ2xaNlhZaAIxCXo0hNN1kskv2", // leo
  "Whkyl6XqGMcmxTsp9yJcgHToEMH3", // leo
])

// Set REACT_APP_ENABLE_LESSON_NOTIFICATIONS="false" to restrict to the allowlist.
const ENABLE_LESSON_NOTIFICATIONS_FOR_ALL =
  process.env.REACT_APP_ENABLE_LESSON_NOTIFICATIONS !== "false"

export const FEATURE_FLAGS = {
  allowSharedLessonsSelfBooking: {
    isEnabled: (state: string) => state.toLowerCase() === "tx",
  },
  allowCohortMakeupRequests: {
    isEnabled: () =>
      process.env.REACT_APP_FEATURE_COHORT_MAKEUP_REQUESTS === "true",
  },
  allowLessonNotifications: {
    isEnabled: (userId: string) => {
      if (process.env.REACT_APP_ENV === "test") return true
      if (ENABLE_LESSON_NOTIFICATIONS_FOR_ALL) return true
      return allowLessonNotificationsUsers.has(userId)
    },
  },
}

/**
 * @deprecated Use `isSuperAdminUser` from `@coast/utils` instead.
 */
export function isSuperAdmin(userId: string | undefined) {
  return isSuperAdminUser(userId)
}

export function getImpersonationLink(token: string) {
  return `${window.location.origin}/impersonate/${token}`
}
